import e from "./OrderCycle.ce.vue.js";
import { defineAndRegisterElement as r } from "../../utils/register-element.js";
const o = r(e);
export {
  o as initOrderCycle
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/order-cycle/index.js
// module id = 1318
// module chunks = 67